export default {
  AUTO_GENERATE_RESERVATION_TIMES_LOADING: 'AUTO_GENERATE_RESERVATION_TIMES_LOADING',
  AUTO_GENERATE_RESERVATION_TIMES_REJECT: 'AUTO_GENERATE_RESERVATION_TIMES_REJECT',
  AUTO_GENERATE_RESERVATION_TIMES_FAILED: 'AUTO_GENERATE_RESERVATION_TIMES_FAILED',
  AUTO_GENERATE_RESERVATION_TIMES_SUCCESS: 'AUTO_GENERATE_RESERVATION_TIMES_SUCCESS',

  CLEAR_AUTO_GENERATE_RESERVATION_TIMES: 'CLEAR_AUTO_GENERATE_RESERVATION_TIMES',

  FETCH_RESERVATION_DAYS_LOADING: 'FETCH_RESERVATION_DAYS_LOADING',
  FETCH_RESERVATION_DAYS_REJECT: 'FETCH_RESERVATION_DAYS_REJECT',
  FETCH_RESERVATION_DAYS_FAILED: 'FETCH_RESERVATION_DAYS_FAILED',
  FETCH_RESERVATION_DAYS_SUCCESS: 'FETCH_RESERVATION_DAYS_SUCCESS',

  FETCH_RESERVATION_DAY_DETAILS_LOADING: 'FETCH_RESERVATION_DAY_DETAILS_LOADING',
  FETCH_RESERVATION_DAY_DETAILS_REJECT: 'FETCH_RESERVATION_DAY_DETAILS_REJECT',
  FETCH_RESERVATION_DAY_DETAILS_FAILED: 'FETCH_RESERVATION_DAY_DETAILS_FAILED',
  FETCH_RESERVATION_DAY_DETAILS_SUCCESS: 'FETCH_RESERVATION_DAY_DETAILS_SUCCESS',

  FETCH_RESERVATION_HOUR_DETAILS_LOADING: 'FETCH_RESERVATION_HOUR_DETAILS_LOADING',
  FETCH_RESERVATION_HOUR_DETAILS_REJECT: 'FETCH_RESERVATION_HOUR_DETAILS_REJECT',
  FETCH_RESERVATION_HOUR_DETAILS_FAILED: 'FETCH_RESERVATION_HOUR_DETAILS_FAILED',
  FETCH_RESERVATION_HOUR_DETAILS_SUCCESS: 'FETCH_RESERVATION_HOUR_DETAILS_SUCCESS',

  CHANGE_RESERVATION_DAY_STATUS_LOADING: 'CHANGE_RESERVATION_DAY_STATUS_LOADING',
  CHANGE_RESERVATION_DAY_STATUS_REJECT: 'CHANGE_RESERVATION_DAY_STATUS_REJECT',
  CHANGE_RESERVATION_DAY_STATUS_FAILED: 'CHANGE_RESERVATION_DAY_STATUS_FAILED',
  CHANGE_RESERVATION_DAY_STATUS_SUCCESS: 'CHANGE_RESERVATION_DAY_STATUS_SUCCESS',

  INSERT_NEW_RESERVATION_DAY_LOADING: 'INSERT_NEW_RESERVATION_DAY_LOADING',
  INSERT_NEW_RESERVATION_DAY_REJECT: 'INSERT_NEW_RESERVATION_DAY_REJECT',
  INSERT_NEW_RESERVATION_DAY_FAILED: 'INSERT_NEW_RESERVATION_DAY_FAILED',
  INSERT_NEW_RESERVATION_DAY_SUCCESS: 'INSERT_NEW_RESERVATION_DAY_SUCCESS',

  UPDATE_RESERVATION_DAY_LOADING: 'UPDATE_RESERVATION_DAY_LOADING',
  UPDATE_RESERVATION_DAY_REJECT: 'UPDATE_RESERVATION_DAY_REJECT',
  UPDATE_RESERVATION_DAY_FAILED: 'UPDATE_RESERVATION_DAY_FAILED',
  UPDATE_RESERVATION_DAY_SUCCESS: 'UPDATE_RESERVATION_DAY_SUCCESS',

  UPDATE_RESERVATION_HOUR_LOADING: 'UPDATE_RESERVATION_HOUR_LOADING',
  UPDATE_RESERVATION_HOUR_REJECT: 'UPDATE_RESERVATION_HOUR_REJECT',
  UPDATE_RESERVATION_HOUR_FAILED: 'UPDATE_RESERVATION_HOUR_FAILED',
  UPDATE_RESERVATION_HOUR_SUCCESS: 'UPDATE_RESERVATION_HOUR_SUCCESS',

  UPDATE_RESERVATION_HOUR_STATUS_LOADING: 'UPDATE_RESERVATION_HOUR_STATUS_LOADING',
  UPDATE_RESERVATION_HOUR_STATUS_REJECT: 'UPDATE_RESERVATION_HOUR_STATUS_REJECT',
  UPDATE_RESERVATION_HOUR_STATUS_FAILED: 'UPDATE_RESERVATION_HOUR_STATUS_FAILED',
  UPDATE_RESERVATION_HOUR_STATUS_SUCCESS: 'UPDATE_RESERVATION_HOUR_STATUS_SUCCESS',

  INSERT_NEW_RESERVATION_HOUR_LOADING: 'INSERT_NEW_RESERVATION_HOUR_LOADING',
  INSERT_NEW_RESERVATION_HOUR_REJECT: 'INSERT_NEW_RESERVATION_HOUR_REJECT',
  INSERT_NEW_RESERVATION_HOUR_FAILED: 'INSERT_NEW_RESERVATION_HOUR_FAILED',
  INSERT_NEW_RESERVATION_HOUR_SUCCESS: 'INSERT_NEW_RESERVATION_HOUR_SUCCESS',

  DELETE_RESERVATION_DAY_LOADING: 'DELETE_RESERVATION_DAY_LOADING',
  DELETE_RESERVATION_DAY_REJECT: 'DELETE_RESERVATION_DAY_REJECT',
  DELETE_RESERVATION_DAY_FAILED: 'DELETE_RESERVATION_DAY_FAILED',
  DELETE_RESERVATION_DAY_SUCCESS: 'DELETE_RESERVATION_DAY_SUCCESS',

  DELETE_RESERVATION_HOUR_LOADING: 'DELETE_RESERVATION_HOUR_LOADING',
  DELETE_RESERVATION_HOUR_REJECT: 'DELETE_RESERVATION_HOUR_REJECT',
  DELETE_RESERVATION_HOUR_FAILED: 'DELETE_RESERVATION_HOUR_FAILED',
  DELETE_RESERVATION_HOUR_SUCCESS: 'DELETE_RESERVATION_HOUR_SUCCESS',

  FETCH_RESERVATION_HOURS_LOADING: 'FETCH_RESERVATION_HOURS_LOADING',
  FETCH_RESERVATION_HOURS_REJECT: 'FETCH_RESERVATION_HOURS_REJECT',
  FETCH_RESERVATION_HOURS_FAILED: 'FETCH_RESERVATION_HOURS_FAILED',
  FETCH_RESERVATION_HOURS_SUCCESS: 'FETCH_RESERVATION_HOURS_SUCCESS'
};
